import React from 'react';
import { Row, Col } from 'antd';
import ProgressBar from '../../Progress';

const SkillsProgress = () => (
  <div>
    <h2 className="titleSeparate">Skills</h2>
    <Row gutter={[20, 20]}>
      <Col xs={24} sm={24} md={12}>
        <ProgressBar
          percent={80}
          text="Javascript"
        />
        <ProgressBar
          percent={90}
          text="React Native"
        />
        <ProgressBar
          percent={70}
          text="Gatsby"
        />
        <ProgressBar
          percent={80}
          text="ReactJS"
        />
        <ProgressBar
          percent={30}
          text="Deno/Oak"
        />
        <ProgressBar
          percent={75}
          text="WebGIS-OpenLayers/Leaflet"
        />
        <ProgressBar
          percent={78}
          text="D3.js"
        />
        <ProgressBar
          percent={78}
          text="TypeScript"
        />
      </Col>
      <Col xs={24} sm={24} md={12}>
        <ProgressBar
          percent={65}
          text="GraphQL(Apollo Client)"
        />
        <ProgressBar
          percent={90}
          text="Redux(with thunks/sagas/persist)"
        />
        <ProgressBar
          percent={78}
          text="MongoDB/Postgres/MSSQL"
        />
        <ProgressBar
          percent={75}
          text="NodeJS"
        />
        <ProgressBar
          percent={65}
          text="UT-Jest/Jasmine"
        />
        <ProgressBar
          percent={50}
          text="CMS- Contentful"
        />
        <ProgressBar
          percent={79}
          text="Angular"
        />
        <ProgressBar
          percent={50}
          text="Redis/lokijs"
        />
      </Col>
    </Row>
  </div>
);

export default SkillsProgress;
